import DealPipelineStageState from '../Models/DealPipelineStageState';
import DataGridRequest from './DataGridRequest';
export class DealPipelineStageRequest extends DataGridRequest<DealPipelineStageState> {
    Url = 'deal_pipeline_stage_states/api';
}
